module.exports = __webpack_public_path__ + "img/header.070a975f.png";